//
// VisualSize.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../BIRDModel";
import "../../MediaTarget";
import "@sas-dvr/ltjs-commons/layout/constraints/FlexibilityType";
import "@sas-dvr/ltjs-commons/layout/constraints/PreferredSizeBehaviorType";

var VisualSize = createModule("BIRD::VisualSize", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        flexibility: 4,
        min: 4,
        mediaTarget: 1,
        max: 4,
        preferredSizeBehavior: 4,
        value: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default VisualSize;
